export default {
  title: 'payment method Form',
  detail: 'Create or update payment method',
  nameFa : 'name fa',
  nameEn : 'name en',
  discountPercent:'discount percent',
  status: 'status',
  statusActive: 'active',
  statusInActive: 'inactive',
  back : 'back',
  success : 'success',
  error : 'error',
  save : 'save',
  loading : 'loading',
  saving : 'saving ...',
  placeholderNameFa:'Enter Name fa',
  placeholderNameEn:'Enter Name en',
  placeholderDiscountPercent:'Enter discount percent'





}
